import axios from "../_defaults/user";
import { uploadImage } from '../images';

export async function createCategory({ data }) {
    try {
        const response = await axios.post("/admin-blog/categories", data);
    
        if (response.data) {
            return response.data;
        }
    } catch(error) {
        if(error.response.status === 404) {
            return {}
        }
        throw error;
    }
}

export async function updateCategory({ data, elementId }) {
    try {
        const response = await axios.post(`/admin-blog/categories/${elementId}`, data);
    
        if (response.data) {
            return response.data;
        }
    } catch(error) {
        if(error.response.status === 404) {
            return {}
        }
        throw error;
    }
}

export async function getCategories({ params }) {
    try {
        const response = await axios.get(`/admin-blog/categories`, {params});
    
        if (response.data) {
            return response.data;
        }
    } catch(error) {
        if(error.response.status === 404) {
            return []
        }
        throw error;
    }
}

export async function getCategory({ elementId, params }) {
    try {
        const response = await axios.get(`/admin-blog/categories/${elementId}`, {params});
    
        if (response.data) {
            return response.data;
        }
    } catch(error) {
        if(error.response.status === 404) {
            return {}
        }
        throw error;
    }
}

export async function getPutUrl({ elementId, file }) {
    try {
        const response = await axios.post(`/admin-blog/categories/${elementId}/images`, {
            contentType: file.type,
            extension: file.name.split(".")[1],
        });
    
        if (response.data) {
            return response.data;
        }
        
    } catch (error) {
        throw error;
    }
}

export async function updateImage({ elementId, file }) {
    try {
        const { url, key } = await getPutUrl({ elementId, file });

        await uploadImage({ url, file });

        const response = await updateCategory({
            elementId,
            data: {
                cover: {
                    url: key,
                },
            },
        });

        if (response.data) {
            return response.data;
        }

        return response;
    } catch (error) {
        throw error;
    }
}